import React from 'react';
import { LoadingOrbit, Flex, Text, startViewTransition } from '@chatsdet/ui';
import { useNavigate } from '@tanstack/react-router';
import { apiCatalogDetailRoute } from '../../../router';
import { useApiRequestDetail } from '../../../features/api-catalog/api';
import { ApiRequestDetail, ApiRequestPageActions } from './ApiRequestDrawer';

export function ApiRequestDetailPage() {
  const { requestId } = apiCatalogDetailRoute.useParams();
  const detailQuery = useApiRequestDetail(requestId);
  const navigate = useNavigate();

  const handleCollapse = React.useCallback(() => {
    startViewTransition(() => {
      navigate({ to: '/api-requests', search: { requestId } });
    });
  }, [navigate, requestId]);

  if (detailQuery.isLoading) {
    return (
      <Flex align="center" justify="center" className="py-32">
        <LoadingOrbit />
      </Flex>
    );
  }

  if (!detailQuery.data?.data) {
    return (
      <Flex direction="column" align="center" gap="sm" className="py-16">
        <Text size="lg">Failed to load request detail.</Text>
      </Flex>
    );
  }

  return (
    <div className="drawer-detail-content flex flex-col min-h-[calc(100vh-4rem)]">
      <ApiRequestDetail
        detail={detailQuery.data.data}
        headerActions={<ApiRequestPageActions onCollapse={handleCollapse} />}
      />
    </div>
  );
}
